/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from "react";
import { useTheme } from "../../theme/ThemeContext";

export default function GradientBar({ height = 10, style = {} }) {
    const { theme } = useTheme();
    return (
        <div
            style={{
                width: "100%",
                height: `${height}px`,
                borderTopLeftRadius: theme.cardRadius,
                borderTopRightRadius: theme.cardRadius,
                background:  `linear-gradient(90deg, ${theme.primary}, ${theme.secondary})`,
            }}
        />
    );
}
